//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/Object.js";
import "../no/BasePart.js";
let d=[[],[[[],"NewAlternateIdManager",{R_:{alternate_id_manager:"PDM.AlternateIdManager"}},0,0],[[],"NewDatabaseAttributeManager",{R_:{attribute_manager:"PDM.DatabaseAttributeManager"}},0,0],[[],"Checkout",{},0,0],[["new_file_name"],"AssignPermanentName",{},1,0],[[],"SetDefaultFolderForPart",{},0,0],[["partsToCheckOut","checkOutInput"],"CheckoutParts",{R_:{pdmOperationErrors:"PDM.OperationErrors"}},2,0],[["partsToCheckIn","checkInInput"],"CheckinParts",{R_:{pdmOperationErrors:"PDM.OperationErrors"}},2,0],[["partsToSetPreciseOnSave"],"SetPreciseStructureOnSave",{},1,0],[["imageWidth","imageHight"],"PublishHdImagesForModelViews",{},2,0],[["isCheckedOut","checkedOutBy"],"GetCheckedoutStatusAndUser",{},0,0],[["nonMasterFileType","numNonMasterFiles"],"ListNonMasters",{R_:{nonMasterFileNames:""}},1,0],[[],"IsModifiable",{R_:{isModifiable:''}},0,0],[["owner","group"],"GetOwnerAndGroup",{},0,0],[["numProjects"],"GetProjects",{R_:{projects:""}},0,0],[[],"GetReleaseStatus",{R_:{releaseStatus:''}},0,0],[["pcaexpressionsInInput"],"ApplyVariantExpressions",{},1,0],[["nObjects"],"GetRelatedDrawings",{R_:{relatedDrawingsCliSpecs:""}},0,0],[["nObjects"],"GetRelatedDrawingSpecs",{R_:{relatedDrawingsCliSpecs:""}},0,0],[["cancelPreciseOnSave"],"ClearPreciseStructureOnSave",{},1,0],[["nObjects"],"GetRelatedGeometryRepresentationSpecs",{R_:{relatedGeometryCliSpecs:""}},0,0]],[]];
SPLM.PDM.PdmPart = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PDM.PdmPart";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.PdmPart.CheckoutInput = class{
    constructor(inputComment,inputChangeId,allowRemote,explicitCheckOut,includeSecondary){
        this.inputComment=inputComment;this.inputChangeId=inputChangeId;this.allowRemote=allowRemote;this.explicitCheckOut=explicitCheckOut;this.includeSecondary=includeSecondary;}
    get Inputcomment(){return this.inputComment}
    set Inputcomment(val){this.inputComment = val}
    get Inputchangeid(){return this.inputChangeId}
    set Inputchangeid(val){this.inputChangeId = val}
    get Allowremote(){return this.allowRemote}
    set Allowremote(val){this.allowRemote = val}
    get Explicitcheckout(){return this.explicitCheckOut}
    set Explicitcheckout(val){this.explicitCheckOut = val}
    get Includesecondary(){return this.includeSecondary}
    set Includesecondary(val){this.includeSecondary = val}
};

SPLM.PDM.PdmPart.CheckinInput = class{
    constructor(allowRemote,explicitCheckIn,includeSecondary){
        this.allowRemote=allowRemote;this.explicitCheckIn=explicitCheckIn;this.includeSecondary=includeSecondary;}
    get Allowremote(){return this.allowRemote}
    set Allowremote(val){this.allowRemote = val}
    get Explicitcheckin(){return this.explicitCheckIn}
    set Explicitcheckin(val){this.explicitCheckIn = val}
    get Includesecondary(){return this.includeSecondary}
    set Includesecondary(val){this.includeSecondary = val}
};

SPLM.PDM.PdmPart.PcaexpressionsInput = class{
    constructor(name,value,unit,savedVariants,optionfamily,optionName){
        this.name=name;this.value=value;this.unit=unit;this.savedVariants=savedVariants;this.optionfamily=optionfamily;this.optionName=optionName;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Savedvariants(){return this.savedVariants}
    set Savedvariants(val){this.savedVariants = val}
    get Optionfamily(){return this.optionfamily}
    set Optionfamily(val){this.optionfamily = val}
    get Optionname(){return this.optionName}
    set Optionname(val){this.optionName = val}
};

export default SPLM;